import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiPhone, FiMail, FiMapPin } = FiIcons;

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="container mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-bold mb-4">Employer Lawyer LA</h3>
            <p className="text-gray-300 mb-4">
              Aggressively defending California businesses for over 30 years. 
              We exclusively represent employers against unfair labor laws and frivolous employee claims.
            </p>
            <p className="text-sm text-gray-400">
              Attorney John Fagerholm - California State Bar
            </p>
          </div>
          
          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Information</h4>
            <div className="space-y-3">
              <div className="flex items-center">
                <SafeIcon icon={FiPhone} className="mr-3 text-blue-400" />
                <a href="tel:323-990-8118" className="hover:text-blue-400 transition-colors">
                  (323) 990-8118
                </a>
              </div>
              <div className="flex items-center">
                <SafeIcon icon={FiMail} className="mr-3 text-blue-400" />
                <a href="mailto:info@employerlawyerla.com" className="hover:text-blue-400 transition-colors">
                  contact@employerlawyerla.com
                </a>
              </div>
              <div className="flex items-center">
                <SafeIcon icon={FiMapPin} className="mr-3 text-blue-400" />
                <span>Los Angeles, California</span>
              </div>
            </div>
          </div>
          
          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Our Services</h4>
            <ul className="space-y-2 text-gray-300">
              <li>Employment Law Defense</li>
              <li>Wrongful Termination Defense</li>
              <li>Discrimination Claims Defense</li>
              <li>Wage & Hour Compliance</li>
              <li>Workplace Policy Development</li>
              <li>HR Legal Consultation</li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-700 mt-8 pt-8 text-center">
          <p className="text-gray-400">
            © 2025 Employer Lawyer LA. All rights reserved. | 
            <span className="ml-2">Revival Tech Firm</span>
          </p>
          <p className="text-sm text-gray-500 mt-2">
            This website is for informational purposes only and does not constitute legal advice. 
            Past results do not guarantee future outcomes.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;